import { FormBuilder } from '@ginkgo-bioworks/react-json-schema-form-builder';
import { useContext } from 'react';
import { FeatureContext } from '../../../Context';
import './Form.css';

const Form = () => {

  const context = useContext(FeatureContext);
  return (<>
    <FormBuilder
      schema={context?.form?.frmschema}
      uischema={context?.form?.uischema}
      onChange={(schema, uischema) => {
        context.setForm({ ...context.form, frmschema: schema, uischema: uischema });
      }} />
  </>)
}

export default Form;